import { render } from "./VipUserSearchInfoDialog.vue?vue&type=template&id=82d7df4c&scoped=true"
import script from "./VipUserSearchInfoDialog.vue?vue&type=script&lang=js"
export * from "./VipUserSearchInfoDialog.vue?vue&type=script&lang=js"

import "./VipUserSearchInfoDialog.vue?vue&type=style&index=0&id=82d7df4c&scoped=true&lang=css"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82d7df4c"]])

export default __exports__